import { createApp } from 'vue';
import V3ScrollLock from 'v3-scroll-lock';
import Forms from '../vue/znforms/Forms.vue';

export default class ZNForms {
    constructor(el) {
        this.el = el;
		
		this.vueComponent = createApp(Forms, {
			data: JSON.parse(this.el.querySelector('script').textContent),
		})
		.use(V3ScrollLock, {});
		this.vueComponent.mount(this.el);
	}
}
